import { useSubscribeToPublicWebsocketEvent } from '~/core/shared/contexts/websockets';
import { AnyDocument } from '../../../../types';
import { buildDocumentChannelName } from '../../logic/buildDocumentChannelName';
import { DocumentPrivateWebsocketEvent } from '../../types/DocumentPrivateWebsocketEvent';
import { DocumentPrivateWebsocketEventPayload } from '../../types/DocumentPrivateWebsocketEventPayload';

export const useSubscribeToDocumentNotification = (
  documentId: AnyDocument['id'],
  onUpdate: (
    payload: DocumentPrivateWebsocketEventPayload[DocumentPrivateWebsocketEvent.DocumentNotification],
  ) => void,
): void => {
  useSubscribeToPublicWebsocketEvent(
    buildDocumentChannelName(documentId),
    DocumentPrivateWebsocketEvent.DocumentNotification,
    onUpdate,
  );
};
